import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { ellipsis } from '_assets/css/global';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const organizationNameContainerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: fit-content;
  margin: 0 var(${SpacingToken.Spacing6}) 0 0;

  ${MEDIA_MIN_SM} {
    max-width: 436px;
  }
`;

export const yourOrganizationStyles = css`
  color: var(${DesignToken.ContentBasicSecondary});
  display: flex;
  justify-content: flex-start;
  text-align: left;
`;

export const organizationNameStyles = (isMenuVisible: boolean) => css`
  ${ellipsis}
  text-align: left;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  max-width: 200px;
  ${MEDIA_MIN_SM} {
    max-width: 436px;
  }

  &:hover {
    white-space: normal;
    overflow: visible;
    display: block;
  }

  ${isMenuVisible &&
  `
    white-space: normal;
    overflow: visible;
    display: block;
  `}
`;
